import type { LocationQuery, LocationQueryValue } from "vue-router";

export function locationQueryToString(query: LocationQuery): string {
  const params = new URLSearchParams();

  for (const [key, value] of Object.entries(query)) {
    if (Array.isArray(value)) {
      for (const v of value) {
        if (v !== null) params.append(key, v);
      }
    } else if (value !== null) {
      params.append(key, value);
    }
  }

  return params.toString();
}

export function firstQueryValue(
  query?: LocationQueryValue | LocationQueryValue[],
): string | null {
  if (query == null) return null;

  return Array.isArray(query) ? (query[0] ?? "") : query;
}

export function getRouteParam(
  param: string | string[] | undefined,
  fallback = "",
): string {
  return (Array.isArray(param) ? param[0] : param) ?? fallback;
}

export function paramToString(p: string | string[] | undefined): string | null {
  return (Array.isArray(p) ? p[0] : p) ?? null;
}
